import { BrandAccent } from './BrandAccent';
import { Button } from './Button';

interface NotFoundProps {
  message?: string;
  buttonLabel?: string;
}

export function NotFound({
  message = 'Page not found',
  buttonLabel = 'Go Home',
}: NotFoundProps) {
  return (
    <div className="flow py-16">
      <BrandAccent variant="long" />
      <h1 className="text-static-60 text-fg-header leading-none font-semibold">
        404
      </h1>
      <p className="text-fg-utility">{message}</p>
      <Button
        variant="outline-primary"
        size="md"
        to="/"
        suffixIcon="arrow-right"
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
